<template>
  <div class="sonar-skills-progress">
    <div class="sonar-skills-progress__data-container">
      <div class="sonar-skills-progress__header">
        <div class="sonar-skills-progress__title-wrapper">
          <h5 v-if="!isResultsModal" class="sonar-skills-progress__la-name">
            {{ currentScore.name }}
          </h5>
          <h5 class="sonar-skills-progress__title">
            {{ cardTitle }}
          </h5>
        </div>
      </div>
      <div class="sonar-skills-progress__results-container">
        <section
          v-for="(group, index) in currentScore.user_status.groups"
          :key="`${index}-gp`"
          class="sonar-skills-progress__results-wrapper"
        >
          <div class="sonar-skills-progress__group-wrapper">
            <img
              v-if="groupIcon(group.name)"
              class="sonar-skills-progress__group-icon"
              :src="groupIcon(group.name)"
            />
            <div class="sonar-skills-progress__group-name">
              {{ group.name }}
            </div>
          </div>
          <SonarSkillProgress
            v-for="(skill, index) in group.skill_areas"
            :key="index"
            :isJustTested="isJustTested(skill)"
            :skill="skill"
          />
        </section>
      </div>
    </div>
    <div class="sonar-skills-progress__footer">
      <button
        v-if="!isResultsModal && !isSharingResults"
        class="btn btn--primary sonar-skills-progress__cta"
        @click="goToAllAssessments()"
      >
        Choose your next assessment
      </button>
      <div
        v-else-if="isResultsModal"
        class="sonar-skills-progress__results-cta"
      >
        <button class="btn btn--tertiary" @click="closeModal">Close</button>
        <button class="btn btn--primary">Retake</button>
      </div>
    </div>
  </div>
</template>

<script>
import SonarSkillProgress from '@/sonar/components/SonarSkillProgress.vue'
import { mapGetters } from 'vuex'
import { iconMap } from '@/sonar/helpers/utils'

export default {
  name: 'SonarSkillsProgress',
  components: {
    SonarSkillProgress,
  },
  props: {
    currentScore: {
      type: Object,
      required: true,
    },
    isResultsModal: {
      type: Boolean,
      required: false,
    },
    isSharingResults: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      navBar: document.querySelector('.navbar'),
      mobileNavBar: document.querySelector('.mobile-navbar'),
    }
  },
  computed: {
    ...mapGetters({
      assessments: 'sonar/assessments',
      assessmentAttempt: 'sonar/assessmentAttempt',
      lastAssessment: 'sonar/lastAssessment',
    }),
    cardTitle() {
      return this.isResultsModal
        ? `${this.currentScore.name} skills overview`
        : 'Skill Sonar Scorecard'
    },
  },
  methods: {
    groupName(group) {
      return group[0]?.group
    },
    isJustTested(skill) {
      if (
        !this.lastAssessment?.score_per_skill_area ||
        Object.keys(this.lastAssessment?.score_per_skill_area)?.length === 0
      )
        return false
      return this.lastAssessment?.score_per_skill_area.some(
        ska => ska.id === skill.id
      )
    },
    groupIcon(groupName) {
      const slug = groupName?.toLowerCase().replace(' ', '-')
      return iconMap(slug)
    },
    goToAllAssessments() {
      const navHeight =
        this.navBar?.offsetHeight || this.mobileNavBar?.offsetHeight
      this.$scrollTo(`#all-assessments`, 1000, {
        container: 'body',
        offset: -navHeight - 10,
      })
    },
    closeModal() {
      this.$parent.$parent.$emit('close-modal')
    },
  },
}
</script>

<style lang="scss" scoped>
.sonar-skills-progress {
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 0 10px 10px 0;
  padding: 20px;
  z-index: 10;
  justify-content: space-between;
  @include mobile {
    padding: 40px 50px;
  }
  @include tablet {
    min-height: 468px;
  }
  &__header {
    display: flex;
    align-items: center;
    gap: 20px;
    margin-bottom: 30px;
  }
  &__title-wrapper {
    display: flex;
    flex-direction: column;
  }
  &__la-name {
    color: var(--perfume);
    font-size: rem(16);
    line-height: rem(24);
    margin: 0;
  }
  &__title {
    font-size: rem(20);
    line-height: rem(26);
    color: var(--white);
    font-family: var(--font-bold);
    margin: 0;
  }
  &__read-score {
    font-size: rem(14);
    line-height: rem(20);
    color: var(--purple-pale);
    margin: 0 47px 0 auto;
  }
  &__group-wrapper {
    display: flex;
    align-items: center;
    height: 30px;
    font-size: rem(16);
    line-height: rem(23);
    font-weight: 700;
    color: var(--white);
    margin-bottom: -2.5px;
  }
  &__group-icon {
    max-height: 26px;
    max-width: 26px;
    margin-right: 12px;
  }
  &__group-difficulty {
    margin-left: auto;
  }
  &__results-container {
    display: flex;
    flex-direction: column;
    gap: 22px;
  }
  &__results-wrapper {
    display: flex;
    flex-direction: column;
    gap: 7.5px;
  }
  &__footer {
    display: flex;
    align-items: flex-end;
    margin-top: 30px;
    height: 100%;
  }
  &__cta {
    width: 100%;
    height: 36px;
    padding: 8px 16px;
    @include mobile {
      width: fit-content;
      margin-left: auto;
      height: 47px;
      padding: 12px 24px;
    }
  }
  &__results-cta {
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    width: 100%;
    gap: 20px;
  }
  &--results {
    background: var(--glass-mid-gray);
  }
}
</style>
